import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { AccessoriesListFragmentDoc } from '../../AccessoriesList/__generated__/AccessoriesList.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAccessoriesEditByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type GetAccessoriesEditByIdQuery = { __typename?: 'Query', getAccessoriesById: { __typename?: 'Accessories', id: string, title: string, price: number, image: string, active?: boolean | null, subtitle: string, category: { __typename?: 'Category', id: string, name: string } } };


export const GetAccessoriesEditByIdDocument = gql`
    query getAccessoriesEditById($id: ID!) {
  getAccessoriesById(id: $id) {
    ...AccessoriesList
  }
}
    ${AccessoriesListFragmentDoc}`;

/**
 * __useGetAccessoriesEditByIdQuery__
 *
 * To run a query within a React component, call `useGetAccessoriesEditByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessoriesEditByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessoriesEditByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccessoriesEditByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAccessoriesEditByIdQuery, GetAccessoriesEditByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessoriesEditByIdQuery, GetAccessoriesEditByIdQueryVariables>(GetAccessoriesEditByIdDocument, options);
      }
export function useGetAccessoriesEditByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessoriesEditByIdQuery, GetAccessoriesEditByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessoriesEditByIdQuery, GetAccessoriesEditByIdQueryVariables>(GetAccessoriesEditByIdDocument, options);
        }
export type GetAccessoriesEditByIdQueryHookResult = ReturnType<typeof useGetAccessoriesEditByIdQuery>;
export type GetAccessoriesEditByIdLazyQueryHookResult = ReturnType<typeof useGetAccessoriesEditByIdLazyQuery>;
export type GetAccessoriesEditByIdQueryResult = Apollo.QueryResult<GetAccessoriesEditByIdQuery, GetAccessoriesEditByIdQueryVariables>;